


class Forms{
            constructor(params) {
            this.Profile = {};
            this.Company = {};
            this.security = {};
        
            Object.keys(params).map((k) => {this.setParameters(params[k]);})
            this.setParameters(params);
        
            
                }
             
            
            setParameters(params){
                    for (var prop in params){
                        if (params.hasOwnProperty(prop)){
                            var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
                            if (this[method]){
                               this[prop] = this[method](params[prop]);
                            }
                            
                        }
                    }
        
                }

            
                setFirstName(val){
                    this.Profile.firstName = val;
                }

                setLastName(val){
                    this.Profile.lastName = val;
                }

                setFullName(val){
                    this.Profile.fullName = val;
                }

                setValue(val){
                    this.Profile.email = val;
                }

                setId(val){
                    return val;
                }

               
                set_sessionEmail(obj){
                   

                } 
            }
            
        export default Forms;
                  